export enum CerberusRoles{
    SensotecAdmin = 0,
    SensotecProduction = 1,
    SensotecSupport = 2,
    Dealer = 3,
    SiteAdmin = 4,
    Supervisor = 5,
    User = 6
}